// extracted by mini-css-extract-plugin
export var box = "_6b-1";
export var checked = "_6b-2";
export var descriptionSpacer = "_6b-9";
export var disabled = "_6b-3";
export var icon = "_6b-6";
export var input = "_6b-0";
export var labelSpacer = "_6b-8";
export var medium = "_6b-5";
export var small = "_6b-4";
export var text = "_6b-7";